import { FormControl, FormControlProps } from '@mui/material'
import { FC } from 'react'

const FormControlWrapper: FC<FormControlProps> = ({ ...props }) => <FormControl {...props} />

export default FormControlWrapper
